import user from '@app/pages/Login/slice';
import snackbar from '@app/components/ReduxSnackbar/slice';

const reducers = {
  user,
  snackbar,
};

export default reducers;
